// CONSUMO DEL RECIBO PARA EL ESTUDIO — el histórico, no un número que el cliente promedió a ojo.
//
// El cotizador GRATIS pide un solo `monthlyKwh` y su propia ayuda le dice al usuario que ponga
// «el promedio de los últimos 6 meses de tu recibo»: o sea que el promedio ya se estaba usando,
// solo que lo calculaba el cliente de memoria y nadie veía los meses. El ESTUDIO (pago) pide los
// seis y dimensiona con el promedio de los que traen dato — y de paso deja el histórico guardado
// en la cotización, que es lo que después mira el técnico en la visita.
//
// Rescatado de `origin/feat/rescate-nuevos` (pila del 14-ago) el 2026-09-01. De esa pila esto es
// lo único que sobrevivió al contraste contra `main`; el resto se descartó con razón escrita en
// `docs/proxima-sesion.md`.

export const MESES_ESTUDIO = 6;

export function mesesVacios(n = MESES_ESTUDIO) {
  return Array.from({ length: n }, () => '');
}

export function etiquetasUltimosMeses(n = MESES_ESTUDIO, ref = new Date()) {
  const fmt = new Intl.DateTimeFormat('es-CO', { month: 'short', year: '2-digit' });
  const out = [];
  for (let i = n - 1; i >= 0; i--) {
    const d = new Date(ref.getFullYear(), ref.getMonth() - i, 1);
    out.push(fmt.format(d));
  }
  return out;
}

/** Promedio de los meses con dato (> 0). Ceros y vacíos no entran. */
export function promedioMeses(meses) {
  const nums = (Array.isArray(meses) ? meses : [])
    .map((v) => Number(v))
    .filter((n) => Number.isFinite(n) && n > 0);
  if (!nums.length) return 0;
  return nums.reduce((a, b) => a + b, 0) / nums.length;
}

export function mesesConDato(meses) {
  return (Array.isArray(meses) ? meses : []).filter((v) => Number(v) > 0).length;
}

/**
 * Consumo que usa el estudio: promedio de los meses del recibo.
 * Si aún no hay meses, cae al kWh/mes que trajo la suite gratuita.
 */
export function consumoEstudio({ meses, fallbackMensual } = {}) {
  const n = mesesConDato(meses);
  const promedio = promedioMeses(meses);
  const fallback = Number(fallbackMensual) || 0;
  const mensual = promedio > 0 ? promedio : fallback;
  return {
    promedioMensual: mensual,
    promedioDiario: mensual > 0 ? mensual / 30 : 0,
    mesesConDato: n,
    importado: n === 0 && fallback > 0,
    fuente: n >= 2
      ? `promedio de ${n} meses del recibo`
      : (n === 1 ? 'un mes del recibo' : (fallback > 0 ? 'promedio importado de la cotización' : 'sin consumo')),
  };
}
